import cls from "@fvilers/cls";
import { HTMLAttributes } from "react";
import styles from "./Heading.module.css";

export type HeadingProps = {
  as?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
  subTitle?: string;
} & HTMLAttributes<HTMLHeadingElement>;

export function Heading({
  as,
  children,
  className,
  subTitle,
  ...props
}: HeadingProps) {
  const Component = as || "h1";
  return (
    <Component {...props} className={cls(styles.Heading, className)}>
      {children}
      {subTitle && <span>{subTitle}</span>}
    </Component>
  );
}
